// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2lLYJ","description":"PatientConsentPreview_description__1apTd"};